var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWellWater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, " .cls-1{isolation:isolate;} .st0{display:none;} .bg-fill-top{fill:url(#SVGID_top_off);} .bg-fill-bot{fill:url(#SVGID_bot_off);stroke:#ADB4CC;stroke-miterlimit:10;} .icon-outline{fill:#8ea9b9;} "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_bot_off",
    gradientUnits: "userSpaceOnUse",
    x1: 34.95,
    y1: 78.5394,
    x2: 34.95,
    y2: -7.332,
    gradientTransform: "matrix(1 0 0 -1 0 70)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#CAE7F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_top_off",
    gradientUnits: "userSpaceOnUse",
    x1: -19.2639,
    y1: 52.95,
    x2: 77.8368,
    y2: 52.95,
    gradientTransform: "matrix(1 0 0 -1 0 70)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9986,
    stopColor: "#F2F2F3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_bot_on",
    cx: 35.9327,
    cy: 93.0101,
    r: 96.4442,
    gradientTransform: "matrix(1 0 0 -1 0 70)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0202796,
    stopColor: "#4E6B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#001554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D183E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_top_on",
    gradientUnits: "userSpaceOnUse",
    x1: 5.2015,
    y1: 68.2395,
    x2: 61.128,
    y2: 36.0928,
    gradientTransform: "matrix(1 0 0 -1 0 70)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00AFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001554"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color_Blocks"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "bg-fill-bot",
    d: "M60.1,69H9.9c-5,0-9.1-4.1-9.1-9.1V10.1C0.9,5,4.9,1,9.9,1H60c5,0,9.1,4.1,9.1,9.1V60 C69.1,65,65.1,69,60.1,69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg-fill-top",
    d: "M35,24.3c12.1,0,23.6,3,33.6,8.2V10.1c0-4.7-3.8-8.6-8.6-8.6H9.9c-4.7,0-8.6,3.8-8.6,8.6v22.5 C11.4,27.3,22.9,24.3,35,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg-fill-bot",
    d: "M60.1,69H9.9c-5,0-9.1-4.1-9.1-9.1V10.1C0.9,5,4.9,1,9.9,1H60c5,0,9.1,4.1,9.1,9.1V60 C69.1,65,65.1,69,60.1,69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg-fill-top",
    d: "M35,24.3c12.1,0,23.6,3,33.6,8.2V10.1c0-4.7-3.8-8.6-8.6-8.6H9.9c-4.7,0-8.6,3.8-8.6,8.6v22.5 C11.4,27.3,22.9,24.3,35,24.3z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Original_Icons",
    className: "st0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Outlined_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon-outline",
    d: "M56.7,22.8h-2.5v-6.2c0-0.6-0.4-1-1-1h-5.4v-3.1c0-0.6-0.4-1-1-1s-1,0.4-1,1v3.1h-2.6v-2.2H25.1v2.2h-3 v-3.1c0-0.6-0.4-1-1-1s-1,0.4-1,1v26.9c0,0.1,0,0.1,0,0.2h-3.9v18.9h36V39.6h-4.5c0-0.1,0-0.1,0-0.2V17.6h4.4v6.2 c0,0.6,0.4,1,1,1h3.5c0.6,0,1-0.4,1-1S57.3,22.8,56.7,22.8z M23.7,41.6v3.7h-5.4v-3.7H23.7z M33,41.6v3.7h-7.4v-3.7H33z M42.2,41.6v3.7H35v-3.7H42.2z M50.3,50.8L50.3,50.8H39.7v-3.5h10.6C50.3,47.3,50.3,50.8,50.3,50.8z M18.3,47.3h10.2v3.5H18.3 V47.3z M37.7,47.3v3.5h-7.2v-3.5H37.7z M33,52.8v3.7h-7.4v-3.7H33z M35,52.8h7.2v3.7H35V52.8z M18.3,52.8h5.4v3.7h-5.4V52.8z M44.2,56.5v-3.7h5.9h0.1v3.7H44.2z M50.3,45.3h-6v-3.7h6V45.3z M45.9,39.6H22.1c0-0.1,0-0.1,0-0.2V17.6h3v2.2h8v0.1v1.9 c-1.8,0.4-3.3,1.8-3.9,3.6c-0.3,0.2-0.4,0.5-0.4,0.8l1.8,8c0.1,0.3,0.4,0.6,0.7,0.6h5.6c0.3,0,0.6-0.2,0.7-0.6l1.6-8 c0.1-0.3-0.1-0.6-0.3-0.7c-0.6-1.9-2.1-3.3-3.9-3.7V20c0-0.1,0-0.1,0-0.1h8.2v-2.2h2.6v21.8C45.8,39.5,45.9,39.5,45.9,39.6z M33.3,22.9c0.2,0.2,0.5,0.4,0.8,0.4s0.6-0.2,0.8-0.4c1.3,0.3,2.5,1.3,3,2.6h-7.6C30.8,24.2,31.9,23.2,33.3,22.9z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellWater);
export default __webpack_public_path__ + "static/media/well-water.f5413727f8259c5113847a3d92f0ae0e.svg";
export { ForwardRef as ReactComponent };